export const environment = {
  production: true,
  homolog: false,
  apiUrl: 'https://api.hudlygo.com.br',
  chatKey: '58B5531534FC460CBABDFF1333DAC840',
  socketUrl: 'wss://tracking-api.conor.com.br/api/socket'
}
